import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Lottie from "lottie-react";
import trashAnim from "../../common/animation/deleteAnimate.json";

const DeleteModal = ({ isOpen, title = "cet élément", onCancel, onConfirm, loading = false }) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={onCancel}
      centered
      style={{ maxWidth: "420px", width: "100%" }}
    >
     <ModalHeader toggle={onCancel} style={{ position: "relative" }}>
  <div
    style={{
      position: "absolute",
      left: "50%",
      transform: "translateX(-50%)",
      fontWeight: 600,
      fontSize: "14px",
      fontFamily: "Poppins"
    }}
  >
    Confirmation de suppression
  </div>
</ModalHeader>

      <ModalBody className="text-center">

        <div style={{ width: 90, margin: "0 auto" }}>
          <Lottie animationData={trashAnim} loop={true} />
        </div>

        <div className="validate-merchent mt-2">
          Êtes-vous sûr de vouloir supprimer <strong>{title}</strong> ?
        </div>

        <div className="validate-merchent mb-3">
          Cette action est <strong>irréversible</strong>.
        </div>

        <div className="d-flex justify-content-center gap-2 mb-4">
          <button
            style={{
              backgroundColor: "#F3F3F3",
              color: "#000",
              padding: "5px 12px",
              fontSize: "14px",
              borderRadius: "8px",
              border: "none",
              cursor: "pointer",
            }}
            onClick={onCancel}
            disabled={loading}
          >
            Annuler
          </button>

          <button
            style={{
              backgroundColor: "#FCE7F3",
              color: "#FB2C36",
              padding: "5px 12px",
              fontSize: "14px",
              borderRadius: "8px",
              border: "none",
              cursor: "pointer",
            }}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <span><i className="fas fa-spinner fa-spin me-2" />Suppression…</span>
            ) : (
              <span><i className="fas fa-trash-alt me-2" />Oui, supprimer</span>
            )}
          </button>
        </div>

      </ModalBody>
    </Modal>
  );
};

export default DeleteModal;